module.exports = __webpack_public_path__ + "assets/urendeclareren7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/documentation/images/urendeclareren7.jpg
// module id = 372
// module chunks = 0